import { getLanguage } from '@nextcloud/l10n';
import { computed } from 'vue';
/**
 * Helper to get the localized value for the current users language
 * @param dict The dictionary to get the value from
 * @param language The language to use
 */
const getLocalizedValue = (dict, language) => dict[language] ?? dict[language.split('_')[0]] ?? dict.en ?? null;
/**
 * Get the localized value of the dictionary provided
 * @param dict Dictionary
 * @return String or null if invalid dictionary
 */
export const useLocalizedValue = (dict) => {
    /**
     * Language of the current user
     */
    const language = getLanguage();
    return computed(() => !dict?.value ? null : getLocalizedValue(dict.value, language));
};
